export default __webpack_public_path__ + "static/media/LocofastInNews_01.19576ebd.webp";